import { DEFAULT_PER_PAGE } from '../const/pagination';

export const getLastPageFromTotalCount = (totalCount: number | undefined, perPage = DEFAULT_PER_PAGE) => {
  return Math.ceil((totalCount ?? 1) / perPage);
};
